"use client";
import { ApolloNextAppProvider } from "@apollo/client-integration-nextjs";
import { makeClient } from "@portal/app/_components/apolloUtils";

export function DreamApolloProvider({ children }: React.PropsWithChildren) {
  return <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
}
